import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { withPlaceholder } from '@sitecore-jss/sitecore-jss-react';
import RenderingStyling from '../../../lib/RenderingStyling';
// Custom GraphQL hook to get field values from Sitecore
import { useGetSitecoreFields } from '../../../services/GraphQLService/useGetSitecoreFields';

const CommunityPostsContainer = ({
  fields,
  CommunityBlogsPlaceHolder,
  CommunityForumsPlaceHolder,
  rendering,
}) => {
  // Fetch Site settings from a Sitecore content item
  const { values } = useGetSitecoreFields(
    '/sitecore/content/Developer2-0/Settings/SiteSettings',
    ['ShowCommunityCardsComponent'],
    'en'
  );
  if (values && values.ShowCommunityCardsComponent) {
    return (
      <section
        className="u-padding-top-2-1/2 u-padding-bottom-2-1/2"
        {...RenderingStyling(rendering.componentName)}
      >
        <div className="md:u-margin-left-2 md:u-margin-right-2">
          <div className="c-container is-full-width">
            <div className="c-row md:is-collapsed">
              <div className="c-col c-col-12">
                <h2 id="popular-posts" className="u-margin-top-0 u-margin-bottom-2">
                  <Text field={fields?.title} />
                </h2>
                <div className="lg:u-padding-left-1 u-display-grid u-gap-2 u-margin-bottom-2 xl:u-grid-auto-flow-column">
                  {CommunityBlogsPlaceHolder}
                </div>
                {CommunityForumsPlaceHolder}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  } else {
    return null;
  }
};

export default withPlaceholder(['CommunityBlogsPlaceHolder', 'CommunityForumsPlaceHolder'])(
  CommunityPostsContainer
);
